export default __webpack_public_path__ + "static/media/Castro.ebeb3043.jpg";